import React from 'react';
import NoDataMsg from 'library/noData';
import CheckInput from 'screens/components/basic/CheckInput';
import SelectInput from 'screens/components/basic/SelectInput';

import DataChart from './DataChart';
import DataGrid from './DataGrid';

const Body = ({ categoryProducts, showComparison, dataForPlotting, selectedPlotNames, customTooltip }) => (
    <div className="row m-0">
        {
            categoryProducts && categoryProducts.list.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div className="row mt-1">
                    <div className="col-xl-10">
                        <h4 className="text-center">{selectedPlotNames[2]}</h4>
                    </div>
                    <div className="col-xl-2 d-flex align-items-center justify-content-end pt-3">
                        <SelectInput
                            defaultValue="units"
                            name="CategoryProductsPlotDropdown"
                            options={
                                [
                                    { text: "Units", value: "units" },
                                    { text: "Cost", value: "cost" },
                                    { text: "Margin %", value: "margin" },
                                    { text: "Markup %", value: "markup" }
                                ]
                            }
                            className="categoryProductsPlotDropdown"
                        />
                    </div>
                    <DataChart dataForPlotting={dataForPlotting} selectedPlotNames={selectedPlotNames} showComparison={showComparison} />
                    <div className="col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                        <CheckInput
                            name={"CategoryProductsShowCompare"}
                            text="Show Comparison with different date"
                            className="checkBoxLabels"
                        />
                    </div>
                    <DataGrid categoryProducts={categoryProducts} showComparison={showComparison} />
                </div>
        }
    </div>
);



export default Body;